import { CustomPDFReportType } from './enums/custom-pdf-report-type.enum';
export const TEARSHEET_REPORT_TYPE = 'Tearsheet';
export const CREATE_REPORT_TYPES = [
    CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW,
    CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON,
    CustomPDFReportType.MULTI_SECURITY_COMPARISON,
    CustomPDFReportType.PRESENTATION,
    TEARSHEET_REPORT_TYPE,
];
export const REPORT_TYPE_LABELS = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: '1 Security',
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: '2 Securities',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: '3+ Securities',
};
export const REPORT_TYPE_LABELS_DEPRECATED = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: 'Overview',
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: 'Comparison',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: 'Multi-Comparison',
    [CustomPDFReportType.PRESENTATION]: 'Presentation',
    [CustomPDFReportType.TEARSHEET_SINGLE_SECURITY]: 'Tearsheet Single Security',
    [CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON]: 'Tearsheet Multi-Comparison',
    [TEARSHEET_REPORT_TYPE]: TEARSHEET_REPORT_TYPE,
};
export const REPORT_TYPE_LOGOS = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: 'icon-template-overview-color',
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: 'icon-template-comp-color',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: 'icon-template-multicomp-color',
    [CustomPDFReportType.PRESENTATION]: 'icon-template-presentation-color',
    [TEARSHEET_REPORT_TYPE]: 'icon-template-tearsheet-color',
};
export const REPORT_TYPE_DESCRIPTIONS = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: 'An overview report of a single security',
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: 'A comparison report of two securities',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: 'A comparison report of 3-7 securities',
};
export const REPORT_TYPE_DESCRIPTIONS_DEPRECATED = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: 'Single security overview in portrait or landscape format',
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: 'Compare 2 securities in portrait or landscape format',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: 'Compare 3 to 6 securities in landscape format',
    [CustomPDFReportType.PRESENTATION]: 'Combine saved charts into a landscape presentation',
    [TEARSHEET_REPORT_TYPE]: 'Condensed reporting for investment overviews or comparisons',
};
export const TEARSHEET_REPORT_TYPES = [
    CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON,
    CustomPDFReportType.TEARSHEET_SINGLE_SECURITY,
];
export const SINGLE_SECURITY_REPORT_TYPES = [
    CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW,
    CustomPDFReportType.TEARSHEET_SINGLE_SECURITY,
];
export const MULTI_SECURITY_REPORT_TYPES = [
    CustomPDFReportType.MULTI_SECURITY_COMPARISON,
    CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON,
];
// Generateable Legacy Report Types
export const LEGACY_REPORT_TYPES = {
    TEARSHEET: 'legacy_tearsheets',
    Y_RATING: 'legacy_y_rating',
};
// PDF Report Preview Constants
export const PDF_PREVIEW_PARAMS = {
    contact_email: 'you@yourcompany.com',
    contact_url: 'www.yourcompany.com',
    contact_phone: '123-456-7890',
    organization: 'Your Company',
    prepared_by: 'Your Name',
    prepared_for: 'Your Client',
    report_title: 'Your Report Title',
    as_of_date_option: 'latest',
};
export const PDF_PREVIEW_SECURITIES = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: {
        security_ids: ['SPY'],
    },
    [CustomPDFReportType.PRESENTATION]: {
        security_ids: ['SPY'],
    },
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: {
        security_ids: ['SPY', 'QQQ'],
    },
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: {
        security_ids: ['SPY', 'QQQ', 'M:VFIAX'],
    },
    [CustomPDFReportType.TEARSHEET_SINGLE_SECURITY]: {
        security_ids: ['SPY'],
    },
    [CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON]: {
        security_ids: ['SPY', 'QQQ', 'M:VFIAX'],
    },
};
// Security Level Options
export const INDIVIDUAL_LEVEL = 'Individual Level';
export const SECURITY_A = 'Security A';
export const CUSTOM = 'Custom';
export const DEFAULT_SECURITY_LEVEL = 10000;
// As Of Date options
export const AS_OF_DATE_LATEST = 'latest';
export const AS_OF_DATE_MONTH_END = 'month_end';
export const AS_OF_DATE_QUARTER_END = 'quarter_end';
export const DATA_SOURCE_OPTIONS = [
    {
        label: 'Default',
        value: 'default',
    },
    {
        label: 'Legacy',
        value: 'legacy',
    },
];
export const AS_OF_DATE_DROPDOWN_CONFIG = {
    list: [
        {
            disabled: false,
            label: 'Latest',
            type: 'option',
            value: AS_OF_DATE_LATEST,
        },
        {
            disabled: false,
            label: 'Month End',
            type: 'option',
            value: AS_OF_DATE_MONTH_END,
        },
        {
            disabled: false,
            label: 'Quarter End',
            type: 'option',
            value: AS_OF_DATE_QUARTER_END,
        },
    ],
};
export const DEFAULT_PERFORMANCE_DISCLOSURE_FOOTNOTE = 'The performance data quoted presents past performance; past performance does not guarantee future results; ' +
    'the investment return and principal value of an investment will fluctuate; an investor’s shares, when ' +
    'redeemed, may be worth more or less than their original cost; current performance may be lower or higher ' +
    'than the performance data quoted. The most recent month end performance data can be accessed at ' +
    'https://go.ycharts.com/fund_contact_info. (See the Standardized Returns section of this report for ' +
    'standardized returns information).';
